<template>
  <agent-default>
    <travel-sale-page channel="agent" />
  </agent-default>
</template>

<script>
import AgentDefault from '@/components/layout/AgentDefault';
import TravelSalePage from '@/components/travel/TravelSalePage';

export default {
  name: 'AgentTravelSale',
  components: { AgentDefault, TravelSalePage },
  metaInfo: { title: 'Travel — Complete Sale' },
};
</script>
